import _ from 'lodash';

export const imgSrc = _.memoize(async (src: string) => {
  const imgPromise = preloadImage(src);
  return imgPromise;
});

export const preloadImage = (src: string) => {
  return new Promise<string>((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      return resolve(src);
    };
    img.onerror = () => {
      return reject;
    };
  });
};
